import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.PayrollAdjustmentVal = function () {
        const dictonary = {
            custom: {
                staffID: {
                    required: () => t.t(dictEnum.LBL_StaffID) + t.t(dictEnum.WARN_IsRequired)
                },
                date: {
                    required: () => t.t(dictEnum.LBL_Date) + t.t(dictEnum.WARN_IsRequired)
                },
                type: {
                    required: () => t.t(dictEnum.LBL_Type) + t.t(dictEnum.WARN_IsRequired)
                },
                particular: {
                    required: () => t.t(dictEnum.LBL_Particular) + t.t(dictEnum.WARN_IsRequired)
                },
                amt: {
                    required: () => t.t(dictEnum.LBL_Amount) + t.t(dictEnum.WARN_IsRequired)
                },
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/100000-Payroll/103000-PayrollAdjustment/PayrollAdjustmentVal.js